import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
interface SpreeRichTextProps {
  /** The `*_html` field: the copy as formatted in the Spree dashboard. */
  html: string | null | undefined;
  /** The plain field: the same copy with the tags stripped. */
  text: string | null | undefined;
  className?: string;
}

/**
 * Renders a Spree rich-text field, such as a product or category description.
 *
 * Spree 6 sends each rich-text field twice: `description` is the copy with
 * the tags stripped, and `description_html` keeps the dashboard's headings,
 * lists and bold. Spree sanitises the HTML on save
 * (`Spree::SanitizableRichText`), so it is rendered as-is.
 *
 * The plain text decides whether there is anything to show, so an editor
 * left holding only empty markup (`<p></p>`) renders nothing. If the HTML is
 * missing, the plain text is shown with its line breaks kept.
 */
export function SpreeRichText(t0) {
  const $ = _c(10);
  const {
    html,
    text,
    className
  } = t0;
  if (!text?.trim()) {
    return null;
  }
  if (html?.trim()) {
    let t1;
    if ($[0] !== html) {
      t1 = {
        __html: html
      };
      $[0] = html;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== className || $[3] !== t1) {
      t2 = <div className={className} dangerouslySetInnerHTML={t1} />;
      $[2] = className;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className, "whitespace-pre-line");
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1 || $[8] !== text) {
    t2 = <div className={t1}>{text}</div>;
    $[7] = t1;
    $[8] = text;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}